import { html, unsafeCSS } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import { createSlotChangeHandler, setInitialSlotProperties } from "@/utilities/slot";
import style from "./alert.css?inline";
import "./alert-light-dom.css";
import "@/components/icon";
import "@/components/button-group";

type SlottedElement = "eko-button" | "eko-button-group" | "eko-table" | null;

@customElement("eko-alert")
class Alert extends EkoElement {
  private static icons = {
    accent: "info-circle",
    danger: "alert-triangle",
    info: "info-circle",
    success: "check-circle",
    warning: "alert-circle",
  } as const;

  private static slotPropertyMap = {
    actions: "actionsElement" as const,
  };

  static styles = [...EkoElement.styles, unsafeCSS(style)];

  private handleSlotChange = createSlotChangeHandler(this, Alert.slotPropertyMap);

  @state()
  actionsElement: SlottedElement = null;

  @property({ reflect: true })
  variant: "accent" | "info" | "danger" | "warning" | "success" = "info";

  firstUpdated() {
    setInitialSlotProperties(this, Alert.slotPropertyMap);
  }

  render() {
    const icon = Alert.icons[this.variant];

    return html`
      <eko-icon name=${icon} part="icon"></eko-icon>
      <span class="eko-alert__content" part="content">
        <slot name="title"></slot>
        <slot></slot>
        <slot
          class="eko-alert__actions"
          name="actions"
          ?hidden=${!this.actionsElement}
          @slotchange=${this.handleSlotChange}></slot>
      </span>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-alert": Alert;
  }
}

export default Alert;
